import moduleActions from "./actions";
import moduleGetters from "./getters";
import moduleMutations from "./mutations";

const initialState = () => ({
  rooms: {}
});

export const rooms = {
  namespaced: true,
  actions: moduleActions,
  getters: moduleGetters,
  mutations: moduleMutations,
  state: initialState
};
